import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import {
  DeviceStatusIconView,
  deviceStatusVariantStyles,
} from '../DeviceStatusBadge';
import { HardwareDeviceStatus } from '../../types/HardwareStatus';
import { getHardwareStatusIcon } from '../../utils/hardwareStatus';
import useStyles from './styles';

type Props = {
  hardwareStatuses: HardwareDeviceStatus[];
  onClose: () => void;
  open: boolean;
};

const HardwareStatusesDialog: React.FC<Props> = ({
  hardwareStatuses,
  onClose,
  open,
}: Props) => {
  const classes = useStyles();

  return (
    <Dialog
      aria-label="All devices"
      fullWidth
      maxWidth="sm"
      onClose={onClose}
      open={open}
    >
      <DialogTitle>{`All devices (${hardwareStatuses.length})`}</DialogTitle>
      <DialogContent className={classes.dialogContent} dividers>
        {hardwareStatuses.map(hardware => {
          const colors = deviceStatusVariantStyles[hardware.variant];

          return (
            <div
              className={classes.deviceRow}
              key={`${hardware.deviceId}-${hardware.deviceType}`}
            >
              <span
                className={classes.deviceIconWrap}
                style={{ backgroundColor: colors.backgroundColor, color: colors.color }}
              >
                <DeviceStatusIconView
                  className={classes.deviceIcon}
                  icon={getHardwareStatusIcon(hardware)}
                />
              </span>
              <div className={classes.deviceInfo}>
                <Typography className={classes.deviceName}>
                  {hardware.deviceName}
                </Typography>
                <Typography className={classes.deviceStatus} style={{ color: colors.color }}>
                  {hardware.label}
                </Typography>
              </div>
            </div>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button color="default" onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(HardwareStatusesDialog);
